import { MapContextState } from '../../models';
import { MapContextActions, MapContextActionTypes } from '../actions/map-context.actions';

export const initialState: MapContextState = {};

export const mapContextReducer = (
  state = initialState,
  action: MapContextActions,
): MapContextState => {
  switch (action.type) {
    case MapContextActionTypes.SetInteractionType: {
      return {
        ...state,
        interactionType: action.interactionType,
      };
    }

    case MapContextActionTypes.SetPreviousInteractionType: {
      return {
        ...state,
        previousInteractionType: action.interactionType,
      };
    }

    case MapContextActionTypes.SetSelectLastYearsFieldEnabled: {
      return {
        ...state,
        selectLastYearsFieldEnabled: action.enabled,
      };
    }

    case MapContextActionTypes.ToggleCropFields: {
      return {
        ...state,
        cropFieldsEnabled: !state.cropFieldsEnabled,
      };
    }

    case MapContextActionTypes.SetRvoEnabled: {
      return {
        ...state,
        rvoEnabled: action.enabled,
      };
    }

    case MapContextActionTypes.SetCropFieldsEnabled: {
      return {
        ...state,
        cropFieldsEnabled: action.enabled,
      };
    }

    case MapContextActionTypes.SetBlightLayerEnabled: {
      return {
        ...state,
        blightLayerEnabled: action.enabled,
      };
    }

    case MapContextActionTypes.SetSoilAnalysesEnabled: {
      return {
        ...state,
        soilAnalysesEnabled: action.enabled,
      };
    }

    case MapContextActionTypes.SaveShapefileFeatures: {
      return {
        ...state,
        shapefileFeatures: action.features,
      };
    }

    default:
      return state;
  }
};
